var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoldenLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46429 5.625V7.5H11.5357V5.625C11.5357 3.89844 10.1772 2.5 8.5 2.5C6.82277 2.5 5.46429 3.89844 5.46429 5.625ZM3.03571 7.5V5.625C3.03571 2.51953 5.48326 0 8.5 0C11.5167 0 13.9643 2.51953 13.9643 5.625V7.5H14.5714C15.9109 7.5 17 8.62109 17 10V17.5C17 18.8789 15.9109 20 14.5714 20H2.42857C1.08906 20 0 18.8789 0 17.5V10C0 8.62109 1.08906 7.5 2.42857 7.5H3.03571Z",
    fill: "url(#paint0_angular_683_201)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_683_201",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.5 10) rotate(90) scale(10 8.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB6BD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B51E0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenLock);
export default __webpack_public_path__ + "static/media/golden-lock.4bd13c4a75149c72d7054d7326ff6471.svg";
export { ForwardRef as ReactComponent };